import posthog from 'posthog-js';

let initialized = false;
let warnedMissingKey = false;
let currentRole = null;

export function initPostHog() {
  if (initialized) return posthog;

  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
  const isDev = import.meta.env.VITE_ENV === 'development' || import.meta.env.DEV;

  if (!key) {
    if (!warnedMissingKey) {
      // eslint-disable-next-line no-console
      console.warn('[analytics] VITE_POSTHOG_KEY not set — analytics disabled.');
      warnedMissingKey = true;
    }
    return posthog;
  }
  if (isDev) return posthog;

  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
    capture_dead_clicks: true,
    disable_session_recording: true,
    person_profiles: 'identified_only',
    persistence: 'localStorage+cookie',
  });

  initialized = true;
  return posthog;
}

export function isAnalyticsEnabled() {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  const isDev = import.meta.env.VITE_ENV === 'development' || import.meta.env.DEV;
  return Boolean(key) && !isDev;
}

export function identify(distinctId, personProps = {}) {
  if (!isAnalyticsEnabled() || !distinctId) return;
  currentRole = personProps.role ?? null;
  posthog.identify(distinctId, personProps);
}

export function reset() {
  if (!isAnalyticsEnabled()) return;
  currentRole = null;
  posthog.reset();
}

export function capture(eventName, properties = {}) {
  if (!isAnalyticsEnabled()) return;
  const payload = { ...properties };
  if (currentRole && payload.user_role === undefined) {
    payload.user_role = currentRole;
  }
  posthog.capture(eventName, payload);
}

export function page(pageName, properties = {}) {
  if (!isAnalyticsEnabled()) return;
  posthog.capture('$pageview', { page_name: pageName, ...properties });
}

export { posthog };
